/* DataTable — minimal reusable table with sticky header, hover row tint,
   and zebra striping. Accepts columns:[{key,label,width,align,render}],
   rows:[...], rowKey:fn, onRowClick:fn? */
import React from "react";
import { P } from "../../shared/constants";
var E = React.createElement;

export default function DataTable(props){
  var cols = props.columns || [];
  var rows = props.rows || [];
  var rowKey = props.rowKey || function(r,i){return r.id||i};
  var caption = props.caption;
  return E("div",{style:{overflowX:"auto",borderRadius:12,border:"1px solid "+P.bdr,background:P.card}},
    E("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
      caption?E("caption",{style:{padding:"10px 14px",textAlign:"left",
        fontSize:12,fontWeight:700,color:P.slateM,background:P.bgS}},caption):null,
      E("thead",null,
        E("tr",null, cols.map(function(c){
          return E("th",{key:c.key,scope:"col",
            style:{position:"sticky",top:0,padding:"10px 12px",textAlign:c.align||"left",
              background:P.bgS,borderBottom:"1px solid "+P.bdr,fontWeight:700,
              color:P.slateM,fontSize:11,whiteSpace:"nowrap",width:c.width||"auto"}},
            c.label);
        }))),
      E("tbody",null,
        rows.length===0 ? E("tr",null,
          E("td",{colSpan:cols.length,style:{padding:24,textAlign:"center",color:P.slateM,fontSize:12}},
            props.emptyText || "No rows")) :
        rows.map(function(row,i){
          var k = rowKey(row,i);
          var clickable = !!props.onRowClick;
          return E("tr",{
            key:k,
            tabIndex:clickable?0:undefined,
            onClick:clickable?function(){props.onRowClick(row,i)}:undefined,
            onKeyDown:clickable?function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();props.onRowClick(row,i)}}:undefined,
            style:{cursor:clickable?"pointer":"default",
              background:i%2===0?P.card:"#FAFBFE",
              transition:"background .12s"}
          }, cols.map(function(c){
            var val = c.render ? c.render(row,i) : row[c.key];
            return E("td",{key:c.key,
              style:{padding:"10px 12px",borderBottom:"1px solid "+P.bdr,
                textAlign:c.align||"left",verticalAlign:"middle",
                fontFamily:c.mono?"IBM Plex Mono,monospace":"inherit",
                fontSize:c.mono?11:12}}, val==null?"—":val);
          }));
        })))
  );
}
